import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { Box, color, useTheme } from "@mui/system";
import { tokens } from "../../Theme/theme";
import '../../assets/fonts/fonts.css'
import { linearGradientDef } from "@nivo/core";

const BarChart = ({ data }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  console.log(data);
  if (!data) {
    return <Box>Loading....</Box>;
  }
  return (
    // <Box>
    <ResponsiveBar
      data={data}
      keys={["users"]}
      indexBy="age"

      margin={{ top: 40, right: 40, bottom: 60, left: 70 }}

      padding={0.35}
      innerPadding={6}
      borderRadius={12}

      colors={{ scheme: "set3" }}

      defs={[
        linearGradientDef("cyanGlass", [
          { offset: 0, color: "#943bff", opacity: 1 },
          { offset: 100, color: "#b3632bff", opacity: 1 }
        ])
      ]}
      fill={[{ match: "*", id: "cyanGlass" }]}

      theme={{
        background: "transparent",
        textColor: "#ffffff",
        fontFamily: "poppins-reg",
        grid: {
          line: {
            stroke: "#ffffff08",
            strokeWidth: 1,
            strokeDasharray: "6 6"
          }
        },
        axis: {
          ticks: {
            text: {
              fill: "#ffffff80",
              fontSize: 12
            }
          },
          legend: {
            text: {
              fill: "#ffffff",
              fontSize: 13
            }
          }
        },
        tooltip: {
          container: {
            background: "#111",
            color: "#fff",
            borderRadius: 10,
            boxShadow: "0 0 20px #00ffd560",
            fontFamily: "poppins-reg"
          }
        }
      }}

      axisBottom={{
        legendPosition: "middle",
        legendOffset: 45,
        tickPadding: 10,
        tickLabelStyle: {
          fill: "#ffffff80",
          fontSize: 12,
          fontFamily: "poppins-reg"
        }
      }}

      axisLeft={{
        legendPosition: "middle",
        legendOffset: -50,
        tickPadding: 10,
        format: v => Math.round(v),
        tickLabelStyle: {
          fill: "#ffffff80",
          fontSize: 12,
          fontFamily: "poppins-reg"
        }
      }}

      labelSkipHeight={14}
      labelTextColor="#fff"

      motionConfig="gentle"
    />

    // </Box>
  );
};

export default BarChart;
